import api from '@/lib/api';
import { ta } from 'date-fns/locale';

export const userService = {
    getUserDetails: async (Email) => {
        const res = await api.get(`/users/${Email}`, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });
        return res.data;
    },
    addUserTags : async (tagName : string) => {
        const res = await api.post(`/user-tags`, {tagName}, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });
        return res.data;
    },
    deleteUserTag : async (tagName : string) => {
        const res = await api.delete(`/user-tags/${tagName}`, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem('fieldOsAccessToken')}`
            }
        });
        return res.data;
    }

}